










import { Component, Vue } from "vue-property-decorator";
import MemberForm from "@/components/sale/forms/MemberForm.vue";

@Component({
  components: { MemberForm },
})
export default class extends Vue {}
